import { render, staticRenderFns } from "./MaterialsOrderCustomQuantity.vue?vue&type=template&id=673a3b2e&scoped=true"
import script from "./MaterialsOrderCustomQuantity.vue?vue&type=script&lang=js"
export * from "./MaterialsOrderCustomQuantity.vue?vue&type=script&lang=js"
import style0 from "./MaterialsOrderCustomQuantity.vue?vue&type=style&index=0&id=673a3b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673a3b2e",
  null
  
)

export default component.exports